interface Payload {
    token: string;
    id: string;
    isAuth: boolean;
}

export type AuthAction =
    | { type: "SET_AUTH"; payload: Payload }
    | { type: "CLEAR_AUTH" };

interface AuthState {
    token: string;
    id: string;
    isAuth: boolean;
}

const initialState: AuthState = {
    token: "",
    id: "",
    isAuth: false,
};

const auth = (state = initialState, action: AuthAction) => {
    switch (action.type) {
        case "SET_AUTH":
            return action.payload;
        case "CLEAR_AUTH":
            return initialState;
        default:
            return state;
    }
};

export default auth;
